










import Vue from 'vue';
import PageFetchHook from '@/components/mixins/PageFetchHook';
import store from '@/store';
import * as CoverLetterStore from '@/containers/cover-letters/store';
import EditContainer from '@/containers/cover-letters/edit.vue';

const fetch = async params => {
  const { id } = params;
  await Promise.all([
    store.dispatch(CoverLetterStore.GetCoverLetter.namespaced({ id })),
  ]);
};

export default Vue.extend({
  // NOTE: DO NOTE reset state of CoverLetterStore
  components: {
    EditContainer,
  },
  mixins: [PageFetchHook(fetch)],
});
